import { API, Endpoints } from '@brg/api';
import { useCallback } from 'react';

export const useDeleteLMSModule = () => {
    const deleteModule = useCallback(async (projectId: string): Promise<boolean> => {
        if (!projectId) return false;
        try {
            const res = await API.fetch(`${Endpoints.geoGateway}/api/LMS/delete/${projectId}`, {
                method: 'DELETE',
                headers: { 'Content-type': 'application/json; charset=UTF-8' },
            });
            return res?.status >= 200 && res?.status < 300;
        } catch {
            return false;
        }
    }, []);

    return { deleteModule };
};
import { API, Endpoints } from '@brg/api';
import { useCallback } from 'react';

export const useDeleteLMSModule = () => {
    const deleteModule = useCallback(async (projectId: string): Promise<boolean> => {
        if (!projectId) return false;
        try {
            const res = await API.fetch(`${Endpoints.geoGateway}/api/LMS/delete/${projectId}`, {
                method: 'DELETE',
                headers: { 'Content-type': 'application/json; charset=UTF-8' },
            });
            return res?.status >= 200 && res?.status < 300;
        } catch {
            return false;
        }
    }, []);

    return { deleteModule };
};
